<template>
  <div class="service" style="width: 480px;
    height: 360px;
    background: url('http://0block.inslow.com/image/bannner.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    cursor: pointer;">
    <div class="service-1" style="position: absolute;
      top: 20px;
      right: 4%;">
      <img style="width: 15px;
        height: 15px;" src="http://0block.inslow.com/image/close.png" alt="">
    </div>
    <div class="s-c" style="width: 92%;
      margin: 0 auto;">
      <div class="s-1" style="font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #0C1364;
        padding-top: 90px;">您好，欢迎访问本站！请问有什么可以帮到您？</div>
      <div class="s-2" style="margin-top: 16px;
        display: flex;">
        <div class="s-l" style="width: 90px;
          height: 36px;
          background: #015CF0;
          border-radius: 12px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 36px;
          text-align: center;">在线咨询</div>
        <div class="s-r" style="width: 90px;
          height: 36px;
          border: 1px solid #015CF0;
          border-radius: 12px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #494949;
          line-height: 36px;
          text-align: center;
          margin-left: 28px;">稍后再说</div>
      </div>
      <div class="s-3" style="margin-top: 55px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #015CF0;">
        <span>联系地址：四川成都武侯区天府新谷</span>
        <span>联系电话：18190795870</span>
      </div>
      <div class="s-4">
        <textarea style="width: 100%;margin-top: 12px;background: #f8f8f8;" placeholder="在此输入可直接对话" name="在此输入可直接对话" id="" maxlength="200" cols="30" rows="10"></textarea>
      </div>
    </div>
    <div class="s-5" style="width: 60px;
        height: 32px;
        border: 1px solid #0600FF;
        border-radius: 6px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #35353D;
        text-align: center;
        line-height: 32px;
        position: absolute;
        right: 4%;
        bottom: 20px;">
      发送
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {

    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
  // .service {
  //   width: 480px;
  //   height: 360px;
  //   background: url('http://0block.inslow.com/image/bannner.png') no-repeat;
  //   background-size: 100% 100%;
  //   position: relative;
  //   cursor: pointer;
  //   .service-1 {
  //     position: absolute;
  //     top: 20px;
  //     right: 4%;
  //     img {
  //       width: 15px;
  //       height: 15px;
  //     }
  //   }
  //   .s-c {
  //     width: 92%;
  //     margin: 0 auto;
  //     .s-1 {
  //       font-size: 14px;
  //       font-family: PingFang SC;
  //       font-weight: 400;
  //       color: #0C1364;
  //       padding-top: 90px;
  //     }
  //     .s-2 {
  //       margin-top: 16px;
  //       display: flex;
  //       .s-l {
  //         width: 90px;
  //         height: 36px;
  //         background: #015CF0;
  //         border-radius: 12px;
  //         font-size: 18px;
  //         font-family: PingFang SC;
  //         font-weight: 400;
  //         color: #FFFFFF;
  //         line-height: 36px;
  //         text-align: center;
  //       }
  //       .s-r {
  //         width: 90px;
  //         height: 36px;
  //         border: 1px solid #015CF0;
  //         border-radius: 12px;
  //         font-size: 18px;
  //         font-family: PingFang SC;
  //         font-weight: 400;
  //         color: #494949;
  //         line-height: 36px;
  //         text-align: center;
  //         margin-left: 28px;
  //       }
  //     }
  //     .s-3 {
  //       margin-top: 55px;
  //       display: flex;
  //       justify-content: space-between;
  //       font-size: 12px;
  //       font-family: PingFang SC;
  //       font-weight: 400;
  //       color: #015CF0;
  //     }
  //   }
  //   .s-5 {
  //       width: 60px;
  //       height: 32px;
  //       border: 1px solid #0600FF;
  //       border-radius: 6px;
  //       font-size: 16px;
  //       font-family: PingFang SC;
  //       font-weight: 400;
  //       color: #35353D;
  //       text-align: center;
  //       line-height: 32px;
  //       position: absolute;
  //       right: 4%;
  //       bottom: 20px;
  //     }
  // }
</style>
